import styles from './index.module.sass'
import { useState } from 'react'
interface Props {
    size?: number | string
    width?: number | string
    height?: number | string
    zIndex?: number
    handler: () => void
    isCross?: boolean
}

export const MenuIcon = ({
    zIndex,
    handler,
    height,
    width,
    size = 29,
    isCross = false,
}: Props) => {
    const iconWith = width ?? size
    const iconHeight = height ?? size
    return (
        <button style={{ position: 'relative', zIndex }} onClick={handler}>
            {!isCross ? (
                <svg
                    style={{
                        width: iconWith + 'px',
                        height: iconHeight + 'px',
                    }}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z"
                        fill="white"
                    />
                </svg>
            ) : (
                <svg
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.82 17.4999L26.3142 11.0058C26.6224 10.6981 26.7958 10.2806 26.7961 9.84512C26.7965 9.40963 26.6239 8.99182 26.3162 8.68361C26.0086 8.3754 25.5911 8.20203 25.1556 8.20165C24.7201 8.20126 24.3023 8.37389 23.9941 8.68156L17.4999 15.1757L11.0058 8.68156C10.6976 8.37335 10.2795 8.2002 9.84367 8.2002C9.40779 8.2002 8.98977 8.37335 8.68156 8.68156C8.37335 8.98977 8.2002 9.40779 8.2002 9.84367C8.2002 10.2795 8.37335 10.6976 8.68156 11.0058L15.1757 17.4999L8.68156 23.9941C8.37335 24.3023 8.2002 24.7203 8.2002 25.1562C8.2002 25.592 8.37335 26.0101 8.68156 26.3183C8.98977 26.6265 9.40779 26.7996 9.84367 26.7996C10.2795 26.7996 10.6976 26.6265 11.0058 26.3183L17.4999 19.8241L23.9941 26.3183C24.3023 26.6265 24.7203 26.7996 25.1562 26.7996C25.592 26.7996 26.0101 26.6265 26.3183 26.3183C26.6265 26.0101 26.7996 25.592 26.7996 25.1562C26.7996 24.7203 26.6265 24.3023 26.3183 23.9941L19.82 17.4999Z"
                        fill="white"
                    />
                </svg>
            )}
        </button>
    )
}
